"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettings = void 0;
const tslib_1 = require("tslib");
const settings_queries_1 = require("./settings.queries");
const settings_mutations_1 = require("./settings.mutations");
const settings_mappers_1 = require("./settings.mappers");
class PrivateSettings {
    constructor(client) {
        this.client = client;
    }
    get() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.request(settings_queries_1.GET_SETTINGS);
            return (0, settings_mappers_1.mapSettingsToVod)(result.settings);
        });
    }
    update(settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.request(settings_mutations_1.UPDATE_SETTINGS, (0, settings_mappers_1.mapSettingsToGql)(settings));
            return (0, settings_mappers_1.mapSettingsToVod)(result.settings.update.entity);
        });
    }
}
exports.PrivateSettings = PrivateSettings;
//# sourceMappingURL=settings.js.map